// extracted by mini-css-extract-plugin
module.exports = {"main":"Slider_main__2XGy1","label":"Slider_label__3X7xc","container":"Slider_container__5d8Sg","slider":"Slider_slider__3AIWA","rangeValue":"Slider_rangeValue__1VuIg"};